import { buildApiUrl } from 'helper/utility';
import apiCall from './apiRequest';
import endPoints from './endpoints';

export function documentStatusApi(token) {
    return apiCall({
        method: 'get',
        endpoint: endPoints.signDocumentStatus,
        payload: null,
        authToken: token,
    });
}

export function documentSessionApi(token) {
    return apiCall({
        method: 'get',
        endpoint: endPoints.signDocumentSession,
        payload: null,
        authToken: token,
    });
}

export function documentInitiateApi(token) {
    return apiCall({
        method: 'get',
        endpoint: endPoints.signDocumentInitiate,
        payload: null,
        authToken: token,
    });
}

// Graph Statistics API
export function getGraphStatisticsApi(filter_type, token, start_date, end_date) {
    const url = buildApiUrl(endPoints.graphStatistics, filter_type, start_date, end_date);

    return apiCall({
        method: 'GET',
        endpoint: url,
        authToken: token,
    });
}

export function initiateUserPdfReportApi(data, token) {
    return apiCall({
        method: 'POST',
        endpoint: endPoints.initiatePdfReport,
        payload: data,
        authToken: token,
    });
}
